import {
  MessageSquareText, ShoppingBag, Share2, Briefcase,
  GraduationCap, ClipboardList, Lightbulb, PenLine,
} from "lucide-react";

export const CATEGORIES = [
  { id: "mensagens", name: "Mensagens", emoji: "💬", Icon: MessageSquareText, desc: "Mensagens profissionais, para clientes, agradecimentos e respostas rápidas." },
  { id: "vendas", name: "Vendas", emoji: "🛍️", Icon: ShoppingBag, desc: "Descrições de produto, anúncios, ofertas e chamadas para ação." },
  { id: "redes_sociais", name: "Redes sociais", emoji: "📱", Icon: Share2, desc: "Legendas, ideias de vídeo, roteiros e calendário de conteúdo." },
  { id: "trabalho", name: "Trabalho", emoji: "💼", Icon: Briefcase, desc: "E-mails, currículos, apresentações e organização de tarefas." },
  { id: "estudos", name: "Estudos", emoji: "🎓", Icon: GraduationCap, desc: "Resumos, explicações simples, revisões e planos de estudo." },
  { id: "organizacao", name: "Organização", emoji: "📋", Icon: ClipboardList, desc: "Planejamento semanal, rotinas, metas e listas de tarefas." },
  { id: "ideias", name: "Ideias", emoji: "💡", Icon: Lightbulb, desc: "Ideias de conteúdo, negócio, presentes e brainstorming." },
  { id: "textos", name: "Textos", emoji: "✍️", Icon: PenLine, desc: "Reescrever, corrigir, resumir e ajustar o tom de textos." },
];
